import clsx from 'clsx';
import { useMemo } from 'react';

export type DoubleBounceProps = {
  size?: number;
  className?: string;
};

export const DoubleBounce = ({ size, className }: DoubleBounceProps) => {
  const style = useMemo(
    () => (size != null ? { width: `${size}px`, height: `${size}px` } : {}),
    [size]
  );

  return (
    <div
      className={clsx('relative inline-block', className)}
      style={style}
    >
      <div className="animate-double-bounce absolute rounded-full bg-current opacity-100" />
      <div
        className="animate-double-bounce absolute rounded-full bg-current opacity-100"
        style={{ animationDelay: '-0.7s' }}
      />
    </div>
  );
};
